import __ from "../../i18n";
import routes from "../../routing/routes";


export default [
    {
        name: __('Dashboard'),
        key: routes.dashboard.path,
        url: routes.dashboard.getUrl()
    },
    {
        name: __('Enrollments'),
        key: routes.enrollment_management.path,
        url: routes.enrollment_management.getUrl()
    },
    {
        name: __('Combos'),
        key: routes.combo_management.path,
        url: routes.combo_management.getUrl()
    },
    {
        name: __('Course management'),
        key: '@courseManagement',
        items: [
            {
                name: __('Courses'),
                key: routes.course_management.path,
                url: routes.course_management.getUrl()
            },
            {
                name: __('Chapters'),
                key: routes.chapter_management.path,
                url: routes.chapter_management.getUrl()
            },
            {
                name: __('Lessons'),
                key: routes.lesson_management.path,
                url: routes.lesson_management.getUrl()
            },
        ]
    },
    {
        name: __('Quizzes'),
        key: routes.quiz_management.path,
        url: routes.quiz_management.getUrl()
    },
    {
        name: __('Banners'),
        key: routes.banner_management.path,
        url: routes.banner_management.getUrl()
    },
    {
        name: __('Articles'),
        key: routes.article_management.path,
        url: routes.article_management.getUrl()
    },
    {
        name: __('Promotions'),
        key: routes.promotion_management.path,
        url: routes.promotion_management.getUrl()
    },
    {
        name: __('Resources'),
        key: '@resources',
        items: [
            {
                name: __('Images'),
                key: routes.image_management.path,
                url: routes.image_management.getUrl()
            },
            {
                name: __('Videos'),
                key: routes.video_management.path,
                url: routes.video_management.getUrl()
            },
            {
                name: __('Audios'),
                key: routes.audio_management.path,
                url: routes.audio_management.getUrl()
            },
            {
                name: __('Documents'),
                key: routes.document_management.path,
                url: routes.document_management.getUrl()
            },
        ]
    },
    {
        name: __('Users'),
        key: routes.user_management.path,
        url: routes.user_management.getUrl()
    },
];
